import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const FC_COUPON_URL = generateUrl()

const fcCouponServiceApiInstance = axios.create({
    baseURL: `${FC_COUPON_URL}/fc-coupon`
})

fcCouponServiceApiInstance.interceptors.request.use(onRequestSuccess, undefined)
fcCouponServiceApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default fcCouponServiceApiInstance
